import { SessionContext } from '@contexts/session-context';
import { UserPreferenceContext } from '@contexts/user-preference-context';
import { FreshChat } from '@testsigma/atoms';
import React, { useContext } from 'react';
import Draggable from 'react-draggable';

const FreshChatComponent: React.FC = () => {
  const { session } = useContext(SessionContext);
  const { userPreference, setOrUpdatePreference } = useContext(
    UserPreferenceContext,
  );
  const onUserCreated = (response) => {
    const status = response && response.status,
      data = response && response.data;
    if (status === 200) {
      if (data.restoreId) {
        userPreference.preference.fcRestoreId = data.restoreId;
        setOrUpdatePreference(userPreference, () => {
          console.log('freshchar user created');
        });
      }
    }
  };
  return (
    <div className='w-[calc(100vw-260px)] absolute bottom-0 right-8'>
      <Draggable axis='x' bounds='parent'>
        <div className='absolute overflow-visible z-30 w-12 h-12 right-4 bottom-4'>
          <FreshChat
            token='b905859c-c256-471f-ab0a-a4d0829d27ee'
            host='https://wchat.freshchat.com'
            tags={['Websitepricing']}
            email={session?.user?.email}
            firstName={session?.user?.firstName}
            lastName={session?.user?.lastName}
            restoreId={session.fcRestoreId}
            externalId={session?.user.email}
            userProps={{
              domain: session.user.domain,
              isSuperAdmin: session.user.isSuperAdmin,
              isAdmin: session.user.isAdmin,
              subscription_status: session.tenant.subscription.status,
              subscription_plan_id: session.tenant.subscription.plan,
              subscription_total_parallel_runs:
                session.tenant.subscription.totalParallelRuns,
              subscription_trial_end_days:
                session.tenant.subscription.nextRenewalAt,
            }}
            onUserCreated={onUserCreated}
          />
        </div>
      </Draggable>
    </div>
  );
};

export default FreshChatComponent;
